export function getAirbalticApiUrl(path: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.public.airbalticApiUrl}${path}`
}

export function getAirbalticBlogLatestFeedApiUrl(lang: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.public.blogUrl}/${lang}wp-json/wp/v2/latest-feed?count=2`
}

export function getAirbalticBlogCategoryFeedApiUrl(lang: string, slug: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.public.blogUrl}/${lang}wp-json/wp/v2/categories-feed/${slug}`
}

export function getAirbalticFlightHotelApiUrl(path: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.flightHotelApiUrl}${path}`
}
